<template>
    <div class="field">
        <div class="control has-icons-left">
            <input v-model="grade"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="text"
                   placeholder="Type Grade">
            <span class="icon is-small is-left">
                <i class="fas fa-cogs"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            grade: {
                get: function () {
                    return this.$store.getters.getNewCarGrade
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarGrade', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorGrade
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/GradeInput.vue